var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3305_3955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5102 11.4622C12.4866 11.4365 12.4664 11.4087 12.4496 11.3796L9.18173 6.9232H7.37233L14.8183 17.077H16.6277L12.5102 11.4622Z",
    fill: "#B8C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.0039C24 18.6313 18.6274 24.0039 12 24.0039C5.37258 24.0039 0 18.6313 0 12.0039C0 5.37649 5.37258 0.00390625 12 0.00390625C18.6274 0.00390625 24 5.37649 24 12.0039ZM6.46154 6.00012C6.28762 6.00012 6.12846 6.09789 6.04985 6.25304C5.97123 6.40818 5.9865 6.59434 6.08935 6.73459L10.5415 12.8059L6.13518 17.2122C5.95494 17.3925 5.95494 17.6847 6.13518 17.8649C6.31542 18.0452 6.60765 18.0452 6.7879 17.8649L11.0938 13.559L14.2122 17.8115C14.2991 17.9301 14.4374 18.0001 14.5844 18.0001H17.5385C17.7124 18.0001 17.8715 17.9023 17.9502 17.7472C18.0288 17.5921 18.0135 17.4059 17.9107 17.2657L13.4585 11.1943L17.8648 6.78802C18.0451 6.60778 18.0451 6.31555 17.8648 6.1353C17.6846 5.95506 17.3923 5.95506 17.2121 6.1353L12.9062 10.4412L9.78781 6.18873C9.70087 6.07017 9.56264 6.00012 9.41562 6.00012H6.46154Z",
    fill: "#B8C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3305_3955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.f374dece263e603e345fc7070d51ecb5.svg";
export { ForwardRef as ReactComponent };